import React from 'react';
import { Card, Typography, List, Space, Alert, Tag, Row, Col } from 'antd';

const { Title, Paragraph, Text } = Typography;

const CookiePolicy = () => {
  const cookieUsages = [
    {
      title: 'Authentification',
      description: 'Les cookies nous aident à vous reconnaître lorsque vous vous connectez à notre site web, vous évitant ainsi de devoir saisir vos informations d\'identification à chaque visite.',
      color: '#52c41a'
    },
    {
      title: 'Préférences',
      description: 'Les cookies conservent vos préférences et paramètres personnels, tels que la langue choisie ou la région dans laquelle vous vous trouvez.',
      color: '#1890ff'
    },
    {
      title: 'Analyse',
      description: 'Les cookies nous permettent de recueillir des informations sur la manière dont vous utilisez notre site web, afin de comprendre comment nous pouvons l\'améliorer pour vous offrir une meilleure expérience.',
      color: '#faad14'
    },
    {
      title: 'Publicité ciblée',
      description: 'Nous pouvons utiliser des cookies pour afficher des publicités ciblées en fonction de vos intérêts et de votre historique de navigation.',
      color: '#722ed1'
    }
  ];

  const cookieTypes = [
    {
      title: 'Cookies essentiels',
      description: 'Ces cookies sont nécessaires au bon fonctionnement de notre site web et vous permettent d\'accéder à certaines fonctionnalités de base.',
      color: 'red',
      essential: true
    },
    {
      title: 'Cookies de performance',
      description: 'Ces cookies nous aident à collecter des informations sur la façon dont vous utilisez notre site web, ce qui nous permet d\'optimiser ses performances et son accessibilité.',
      color: 'orange',
      essential: false
    },
    {
      title: 'Cookies de fonctionnalité',
      description: 'Ces cookies conservent vos préférences et paramètres personnels pour vous offrir une expérience de navigation plus personnalisée.',
      color: 'blue',
      essential: false
    },
    {
      title: 'Cookies de publicité',
      description: 'Nous pouvons utiliser des cookies de tiers pour afficher des publicités ciblées en fonction de vos intérêts.',
      color: 'purple',
      essential: false
    }
  ];

  return (
    <div className="cookie-policy-page" style={{ padding: '20px 0' }}>
      <div className="container">
        <Card className="mb-4" style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
          {/* En-tête */}
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <Title level={1} style={{ color: '#1890ff' }}>
              Politique en matière de Cookies
            </Title>
            <Paragraph style={{ fontSize: '16px', color: '#666', maxWidth: '800px', margin: '0 auto' }}>
              Chez Nomidya, nous utilisons des cookies pour améliorer votre expérience de navigation sur notre site web. Cette politique a pour objectif de vous informer sur notre utilisation des cookies et technologies similaires.
            </Paragraph>
          </div>

          {/* Qu'est-ce qu'un cookie */}
          <Card style={{ marginBottom: '30px', background: '#f0f2f5' }}>
            <Title level={3} style={{ color: '#1890ff', textAlign: 'center' }}>
              Qu'est-ce qu'un cookie ?
            </Title>
            <Paragraph style={{ fontSize: '16px', lineHeight: '1.7', textAlign: 'justify', margin: 0 }}>
              Un cookie est un petit fichier texte stocké sur votre appareil lorsque vous visitez notre site web. Les cookies sont largement utilisés pour améliorer l'efficacité des sites web et fournir une expérience de navigation plus fluide et personnalisée.
            </Paragraph>
          </Card>

          {/* Comment nous utilisons les cookies */}
          <Card style={{ marginBottom: '30px' }}>
            <Title level={3} style={{ color: '#1890ff', textAlign: 'center', marginBottom: '20px' }}>
              Comment utilisons-nous les cookies ?
            </Title>
            <Row gutter={[16, 16]}>
              {cookieUsages.map((usage, index) => (
                <Col xs={24} md={12} key={index}>
                  <Card 
                    hoverable
                    style={{ 
                      height: '100%',
                      borderTop: `4px solid ${usage.color}`
                    }}
                  >
                    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                      <div style={{ textAlign: 'center' }}>
                        <Title level={4} style={{ color: usage.color, margin: 0 }}>
                          {usage.title}
                        </Title>
                      </div>
                      <Paragraph style={{ 
                        fontSize: '14px', 
                        lineHeight: '1.6', 
                        textAlign: 'justify',
                        margin: 0
                      }}>
                        {usage.description}
                      </Paragraph>
                    </Space>
                  </Card>
                </Col>
              ))}
            </Row>
          </Card>

          {/* Types de cookies */}
          <Card style={{ marginBottom: '30px' }}>
            <Title level={3} style={{ color: '#1890ff', textAlign: 'center', marginBottom: '20px' }}>
              Types de cookies que nous utilisons
            </Title>
            <List
              itemLayout="vertical"
              dataSource={cookieTypes}
              renderItem={(item, index) => (
                <List.Item key={index} style={{ paddingBottom: '16px' }}>
                  <Card 
                    hoverable
                    style={{ 
                      borderLeft: `4px solid ${item.color === 'red' ? '#f5222d' : item.color === 'orange' ? '#fa8c16' : item.color === 'blue' ? '#1890ff' : '#722ed1'}`
                    }}
                  >
                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Title level={4} style={{ 
                          margin: 0, 
                          color: item.color === 'red' ? '#f5222d' : item.color === 'orange' ? '#fa8c16' : item.color === 'blue' ? '#1890ff' : '#722ed1'
                        }}>
                          {item.title}
                        </Title>
                        {item.essential && (
                          <Tag color="red">Essentiel</Tag>
                        )}
                      </div>
                      <Paragraph style={{ 
                        fontSize: '15px', 
                        lineHeight: '1.6', 
                        margin: 0,
                        textAlign: 'justify'
                      }}>
                        {item.description}
                      </Paragraph>
                    </Space>
                  </Card>
                </List.Item>
              )}
            />
          </Card>

          {/* Gestion des préférences */}
          <Card style={{ 
            marginBottom: '30px',
            background: '#fff7e6',
            border: '2px solid #faad14'
          }}>
            <Title level={3} style={{ color: '#faad14', textAlign: 'center' }}>
              Gestion des préférences en matière de cookies
            </Title>
            <Alert
              message="Contrôlez vos cookies"
              description="Vous pouvez gérer vos préférences en matière de cookies en ajustant les paramètres de votre navigateur. Vous pouvez choisir d'accepter tous les cookies, de les refuser ou de recevoir une notification lorsque des cookies sont envoyés."
              type="warning"
              showIcon
              style={{ marginBottom: '16px' }}
            />
            <Alert
              message="Note importante"
              description="Veuillez noter que le blocage des cookies peut affecter votre expérience de navigation sur notre site web."
              type="info"
              showIcon
            />
          </Card>

          {/* Modifications */}
          <Card style={{ marginBottom: '20px' }}>
            <Title level={4} style={{ color: '#eb2f96' }}>
              Modifications de la politique en matière de cookies
            </Title>
            <Paragraph style={{ fontSize: '15px', lineHeight: '1.6', textAlign: 'justify', margin: 0 }}>
              Nous pouvons mettre à jour cette politique en matière de cookies de temps à autre. Les modifications prendront effet dès leur publication sur notre site web. Il est de votre responsabilité de consulter régulièrement cette page pour prendre connaissance des éventuelles mises à jour.
            </Paragraph>
          </Card>

          {/* Message d'acceptation */}
          <Card style={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            textAlign: 'center'
          }}>
            <Title level={3} style={{ color: 'white', marginBottom: '16px' }}>
              Acceptation des Cookies
            </Title>
            <Paragraph style={{ 
              fontSize: '16px', 
              lineHeight: '1.7', 
              color: 'white',
              marginBottom: '16px'
            }}>
              En utilisant notre site web, vous acceptez l'utilisation de cookies conformément à cette politique en matière de cookies.
            </Paragraph>
            <Paragraph style={{ 
              fontSize: '14px', 
              color: '#ffd700',
              margin: 0
            }}>
              Nous vous remercions de votre confiance en choisissant Nomidya pour votre parcours d'apprentissage.
            </Paragraph>
          </Card>

          {/* Contact */}
          <Card style={{ 
            marginTop: '20px',
            background: '#f0f2f5',
            textAlign: 'center'
          }}>
            <Title level={4} style={{ color: '#1890ff', marginBottom: '8px' }}>
              Questions sur les Cookies ?
            </Title>
            <Text style={{ fontSize: '15px' }}>
              Si vous avez des questions concernant notre utilisation des cookies, n'hésitez pas à nous contacter à{' '}
              <Text strong style={{ color: '#1890ff' }}>contact@nomidya.com</Text>
            </Text>
          </Card>
        </Card>
      </div>
    </div>
  );
};

export default CookiePolicy;